export default class IntranetService {
  constructor() {}

  static checkIfConnectedToIntranet() {
    return new Promise(resolve => {
      let img = new Image();

      img.onload = function() {
        if ("naturalHeight" in this) {
          if (this.naturalHeight + this.naturalWidth === 0) {
            this.onerror();
            return;
          }
        } else if (this.width + this.height == 0) {
          this.onerror();
          return;
        }
        console.log("Koblet til intranet");

        resolve(true);
      };

      img.src = process.env.VUE_APP_INTERNAL_PROXY_CHECK_URL;

      img.onerror = function() {
        console.log("Ikke koblet til intranet");
        resolve(false);
      };
    });
  }
}
